import React, { Fragment } from 'react';
import MailingList from './MailingList';

var footerContent = {
    paddingBottom: '2rem'
};

var aboutMeContent = {
    borderTop: '0px solid #f0f0f0',
    paddingTop: '0rem'
};

var aboutMeText = {
  textDecoration: 'none',
  //color: '#ffd656',
  transition: '.3s'
};

const Footer = () => (
  <Fragment>

    <footer className="push">
      <div className="content">
        <div className="footer-content" style={footerContent}>
          <div className="footer-about">
            <div className="footer-header">
              <span className="hide-content"></span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512.25684 50.73779"
                aria-hidden="true">
                <path d="M24.25 49.57h-.7a1.09 1.09 0 0 1-1.19-1l-2.73-12.03H5.49L2.76 48.59a1.09 1.09 0 0 1-1.19 1H1c-.77 0-1.12-.49-1-1.26L10.88 1.54a1.09 1.09 0 0 1 1.19-1h1a1.09 1.09 0 0 1 1.19 1l11 46.77c.11.77-.26 1.26-1.01 1.26zM19 33.88L12.56 5.67 6.12 33.88zM48.68 24.08c4.76.7 5.74 4.69 5.74 7.77v8c0 5.47-3.36 9.67-10.78 9.67H33.49a1 1 0 0 1-1.12-1.12V1.68A1 1 0 0 1 33.49.56h10.29c7.42 0 10.36 4.2 10.36 9.66v6.16c0 3.08-.98 7.28-5.46 7.7zm-13.51-1.19h8.47c5.11 0 7.7-1.89 7.7-5.88v-5.67c0-5.39-1.89-8.12-7.7-8.12h-8.47zm8.75 2.66h-8.75v21.36h8.75c5.81 0 7.7-2.74 7.7-8.13v-7.35c0-3.99-2.62-5.88-7.7-5.88zM73.88 0h.56c7.42 0 10.92 3.64 10.92 10.36v29.4c0 6.73-3.5 10.37-10.92 10.37h-.56C66.46 50.13 63 46.49 63 39.76v-29.4C63 3.57 66.46 0 73.88 0zm.28 47.47c6.16 0 8.4-2.67 8.4-9V11.62c0-6.3-2.24-9-8.4-9s-8.4 2.66-8.4 9V38.5c0 6.3 2.24 8.97 8.4 8.97zM116.58 1.68v38.08c0 6.86-3.36 10.37-10.78 10.37h-.28c-7.42 0-10.78-3.43-10.78-10.37V1.68A1 1 0 0 1 95.86.56h.56a1 1 0 0 1 1.12 1.12V38.5c0 6.3 2 9 8.12 9s8.12-2.67 8.12-9V1.68A1 1 0 0 1 114.9.56h.56a1 1 0 0 1 1.12 1.12zM144.16 1.68v.42A1 1 0 0 1 143 3.22h-8.33v45.23a1 1 0 0 1-1.12 1.12H133a1 1 0 0 1-1.12-1.12V3.22h-8.33a1 1 0 0 1-1.12-1.12v-.42a1 1 0 0 1 1.15-1.12H143a1 1 0 0 1 1.16 1.12z"/>
      <path fill="#ffd656" d="M162.73 31.21V1h6.33v30.37c0 10 4.35 13.58 10.11 13.58s10.26-3.63 10.26-13.58V1h6v30.21c0 13.9-6.8 19.24-16.29 19.24s-16.41-5.34-16.41-19.24zM206.24 43.28L210 39a20.43 20.43 0 0 0 14.2 6c6.65 0 10.48-3.18 10.48-7.6 0-5.17-3.77-6.64-8.65-8.71l-7-3.11c-4.82-1.92-10.44-5.33-10.44-12.51 0-7.4 6.67-12.89 15.93-12.89a21.2 21.2 0 0 1 15 6l-3.28 4a17.05 17.05 0 0 0-11.91-4.51c-5.6 0-9.37 2.65-9.37 7 0 4.65 4.51 6.34 8.65 8l6.8 3c6 2.37 10.73 5.78 10.73 13 0 7.69-6.51 13.84-17.18 13.84a24.73 24.73 0 0 1-17.72-7.23z"/>
              </svg>

            </div>
            <p>
              {"Maybe one day we'll actually get some wearable tech that can do more than just track your steps. But until then, here are some ideas to hold us over in the meantime."} 
            </p>
          </div>
          <nav className="footer-links">
            <dl>
              <dt className="footer-header">

                <span className="hide-content"></span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512.25684 50.73779"
                  aria-hidden="true">
                <path d="M22 31.43v8.33c0 6.86-3.5 10.37-10.92 10.37h-.14C3.5 50.13 0 46.7 0 39.76v-29.4C0 3.78 3.5 0 10.92 0h.14C18.48 0 22 3.78 22 10.36v7.14a1 1 0 0 1-1.12 1.12h-.58a1 1 0 0 1-1.12-1.12v-5.88c0-6.23-2.1-9-8.19-9s-8.19 2.73-8.19 9V38.5c0 6.23 2.1 9 8.19 9s8.19-2.74 8.19-9v-7.07a1 1 0 0 1 1.12-1.12h.56A1 1 0 0 1 22 31.43zM41.86 0h.56c7.42 0 10.92 3.64 10.92 10.36v29.4c0 6.73-3.5 10.37-10.92 10.37h-.56c-7.42 0-10.92-3.64-10.92-10.37v-29.4C30.94 3.57 34.44 0 41.86 0zm.28 47.47c6.16 0 8.4-2.67 8.4-9V11.62c0-6.3-2.24-9-8.4-9s-8.4 2.66-8.4 9V38.5c0 6.3 2.26 8.97 8.4 8.97zM64.54 49.57H64a1 1 0 0 1-1.12-1.12V1.68A1 1 0 0 1 64 .56h.91a1.22 1.22 0 0 1 1.26.84l16.92 41.37V1.68A1 1 0 0 1 84.21.56h.56a1 1 0 0 1 1.12 1.12v46.77a1 1 0 0 1-1.12 1.12H84a1.22 1.22 0 0 1-1.26-.84L65.66 7.35v41.1a1 1 0 0 1-1.12 1.12zM113.61 1.68v.42a1 1 0 0 1-1.12 1.12h-8.33v45.23a1 1 0 0 1-1.16 1.12h-.56a1 1 0 0 1-1.12-1.12V3.22H93a1 1 0 0 1-1.09-1.12v-.42A1 1 0 0 1 93 .56h19.46a1 1 0 0 1 1.15 1.12zM138.11 49.57h-.7a1.09 1.09 0 0 1-1.19-1l-2.73-12.05h-14.14l-2.73 12.05a1.09 1.09 0 0 1-1.19 1h-.56c-.77 0-1.12-.49-1-1.26l10.87-46.77a1.09 1.09 0 0 1 1.19-1h1a1.09 1.09 0 0 1 1.19 1l11 46.77c.11.77-.24 1.26-1.01 1.26zm-5.25-15.69l-6.44-28.21L120 33.88zM167.51 31.43v8.33c0 6.86-3.5 10.37-10.92 10.37h-.14c-7.42 0-10.92-3.43-10.92-10.37v-29.4C145.53 3.78 149 0 156.45 0h.14c7.42 0 10.92 3.78 10.92 10.36v7.14a1 1 0 0 1-1.12 1.12h-.56a1 1 0 0 1-1.12-1.12v-5.88c0-6.23-2.1-9-8.19-9s-8.19 2.73-8.19 9V38.5c0 6.23 2.1 9 8.19 9s8.19-2.74 8.19-9v-7.07a1 1 0 0 1 1.12-1.12h.56a1 1 0 0 1 1.12 1.12zM194.39 1.68v.42a1 1 0 0 1-1.12 1.12h-8.33v45.23a1 1 0 0 1-1.12 1.12h-.56a1 1 0 0 1-1.12-1.12V3.22h-8.33a1 1 0 0 1-1.12-1.12v-.42a1 1 0 0 1 1.12-1.12h19.46a1 1 0 0 1 1.12 1.12z"/>
                <path fill="#ffd656" d="M212.91 31.21V1h6.33v30.37c0 10 4.34 13.58 10.11 13.58s10.26-3.63 10.26-13.58V1h6v30.21c0 13.9-6.8 19.24-16.29 19.24s-16.41-5.34-16.41-19.24zM256.42 43.28l3.72-4.28a20.43 20.43 0 0 0 14.2 6c6.64 0 10.48-3.18 10.48-7.6 0-5.17-3.77-6.64-8.65-8.71l-7-3.11c-4.81-1.92-10.43-5.33-10.43-12.51 0-7.4 6.67-12.89 15.93-12.89a21.18 21.18 0 0 1 14.95 6l-3.27 4a17.05 17.05 0 0 0-11.91-4.51c-5.61 0-9.37 2.65-9.37 7 0 4.65 4.5 6.34 8.65 8l6.8 3c6 2.37 10.73 5.78 10.73 13 0 7.69-6.51 13.84-17.18 13.84a24.73 24.73 0 0 1-17.65-7.23z"/></svg>
              </dt>
              <dd>
                <a href="/">About</a>
              </dd>
              <dd>
                <a href="/">Shipping & Returns</a>
              </dd>
              <dd>
                <a href="/">Privacy Policy</a>
              </dd>
              <dd>
                <a href="/">T&Cs</a>
              </dd>
            </dl>
          </nav>
          <nav className="footer-social">
            <dl>
              <dt className="footer-header">
                <span className="hide-content"></span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 717.25684 50.73779"
                  aria-hidden="true">
                <path d="M0 48.45V1.68A1 1 0 0 1 1.12.56h16.17a1 1 0 0 1 1.12 1.12v.42a1 1 0 0 1-1.12 1.12H2.8v20.51h12.32a1 1 0 0 1 1.12 1.12v.42a1 1 0 0 1-1.12 1.12H2.8v22.06a1 1 0 0 1-1.12 1.12h-.56A1 1 0 0 1 0 48.45zM35.35 0h.56c7.42 0 10.92 3.64 10.92 10.36v29.4c0 6.73-3.5 10.37-10.92 10.37h-.56c-7.42 0-10.92-3.64-10.92-10.37v-29.4C24.43 3.57 27.93 0 35.35 0zm.28 47.47c6.16 0 8.4-2.67 8.4-9V11.62c0-6.3-2.24-9-8.4-9s-8.4 2.66-8.4 9V38.5c0 6.3 2.24 8.97 8.4 8.97zM74.2 48v.42a1 1 0 0 1-1.12 1.12H57.47a1 1 0 0 1-1.12-1.12V1.68A1 1 0 0 1 57.47.56H58a1 1 0 0 1 1.12 1.12v45.23h13.96A1 1 0 0 1 74.2 48zM98.49 48v.42a1 1 0 0 1-1.12 1.12H81.76a1 1 0 0 1-1.12-1.12V1.68A1 1 0 0 1 81.76.56h.56a1 1 0 0 1 1.12 1.12v45.23h13.93A1 1 0 0 1 98.49 48zM115.57 0h.56c7.42 0 10.92 3.64 10.92 10.36v29.4c0 6.73-3.5 10.37-10.92 10.37h-.56c-7.42 0-10.92-3.64-10.92-10.37v-29.4c0-6.79 3.5-10.36 10.92-10.36zm.28 47.47c6.16 0 8.4-2.67 8.4-9V11.62c0-6.3-2.24-9-8.4-9s-8.4 2.66-8.4 9V38.5c0 6.3 2.24 8.97 8.4 8.97zM173.88 1.75l-8 46.77a1.2 1.2 0 0 1-1.19 1h-.77a1.21 1.21 0 0 1-1.26-1l-8.87-42.36-9 42.43a1.09 1.09 0 0 1-1.19 1h-.84a1.2 1.2 0 0 1-1.19-1l-8.01-46.84c-.14-.77.28-1.19 1.05-1.19h.63a1.2 1.2 0 0 1 1.19 1.05l7.07 41.65 8.61-41.72a1.21 1.21 0 0 1 1.26-1h.84a1.21 1.21 0 0 1 1.26 1l8.61 41.72 7.07-41.65a1.2 1.2 0 0 1 1.19-1h.49c.77-.05 1.17.39 1.05 1.14z"/>
                <path fill="#ffd656" d="M193.09 31.21V1h6.33v30.37c0 10 4.35 13.58 10.11 13.58s10.26-3.63 10.26-13.58V1h6v30.21c0 13.9-6.8 19.24-16.29 19.24s-16.41-5.34-16.41-19.24zM236.6 43.28l3.72-4.28a20.43 20.43 0 0 0 14.2 6c6.65 0 10.48-3.18 10.48-7.6 0-5.17-3.77-6.64-8.65-8.71l-7-3.11C244.51 23.61 238.9 20.2 238.9 13c0-7.4 6.66-12.89 15.92-12.89a21.19 21.19 0 0 1 15 6l-3.28 4a17.05 17.05 0 0 0-11.91-4.51c-5.6 0-9.37 2.65-9.37 7 0 4.65 4.51 6.34 8.66 8l6.8 3c6 2.37 10.72 5.78 10.72 13 0 7.69-6.51 13.84-17.18 13.84a24.74 24.74 0 0 1-17.66-7.16z"/>
                </svg>


              </dt>
              <dd>
                <a href="/">Facebook</a>
              </dd>
              <dd>
                <a href="/">Instagram</a>
              </dd>
              <dd>
                <a href="/">Pinterest</a>
              </dd>
              <dd>
                <a href="/">Twitter</a>
              </dd>
            </dl>
          </nav>
        </div>
      </div>
      <div className="content">
        <div className="footer-content" style={aboutMeContent}>
          <div className="footer-about">
          </div>
          <div className="footer-about">
          <small>
          <a style={aboutMeText} href="www.ryanwsheehan.com">Ryan Sheehan</a> | <a style={aboutMeText} href="../../assets/BWT_press_kit.zip">Press Kit</a> | <a style={aboutMeText} href="/about"> About</a> 
          </small>
          </div>
        </div>
      </div>
    </footer>
  </Fragment>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/global/Footer.js